<template>
    <v-app>

        <!-- <v-layout> -->
            <!-- <v-flex xs12> -->
        <scale 
            :model_score="break_score" 
            :model_comment="break_comment" 
            :section="section" 
            :contents="contents"
            :title="title"
            ></scale>
            <!-- </v-flex> -->

            <v-flex xs12 class="form1table" >
            <table>
                <tr>
                    <th>RESIDUAL RISK RATING</th>
                    <th>ACTION REQUIRED</th> 
                   
                </tr>
                <tr>
                    <td><strong>HIGH (H) (>81%)
                    Possibility of serious injury occurring
                    </strong>
                    </td>
                    <td>The activity must not take
                    place at all.
                    You must identify further
                    controls to reduce the risk
                    rating.
                    </td>
                </tr>
                <tr>
                    <td><strong>MEDIUM (M) (41%-80%)
                        Possibility of significant injury
                        or over 3 day absence occurring
                        </strong>
                    </td>
                    <td>If it is not possible to lower risk
                    further, you will need to
                    consider the risk against the
                    benefit. Monitor risk
                    assessments at this rating
                    more regularly and closely.
                    </td>
                </tr>
                <tr>
                    <td><strong>LOW (L) (0-40%)
                    Possibility of minor injury only
                    </strong>
                    </td>
                    <td>No further action required.</td>
                </tr>
            </table>
            </v-flex>
        <!-- </v-layout> -->

    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section'],
    data(){
        return{
            break_score: [],
            break_comment: [],
            na: 0,
            title: "Breaks",
            contents:[
                {
                    question: "Do you take postural breaks every 30 minutes? E.g Standing, Walking",
                    parts: ['General']
                },
                {
                    question: "Do you take regular eye breaks every from looking at your monitor?",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.break_score.length; x++){
                if(this.break_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.break_score[x]
                }
            }
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.break_score.length != this.contents.length || this.break_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            db.collection('forms').doc(id).update(
                {
                    break_score: this.break_score,
                    break_comment: this.break_comment,
                    break_total:score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                alert(e);
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.break_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

<style scoped>
table {
  width:100%;
}
table, th, td {
  /* border: 1px solid black; */
  border-collapse: collapse;
  
}
th, td {
  border: 1px solid black;  
  padding: 15px;
  text-align: left;
}
table tr:nth-child(2) {
    
  background-color: rgba(139, 0, 0, 0.418);
  color: rgb(0, 0, 0);
}
table tr:nth-child(3) {
 background-color: rgba(242, 140, 44, 0.363);
 color: rgb(0, 0, 0);
}
table tr:nth-child(4) {
 background-color: rgba(0, 160, 0, 0.356);
 color: rgb(0, 0, 0);
}
table th {
  background-color: rgb(131, 131, 131);
  color: rgb(0, 0, 0);
}

.form1table {
    position:absolute;
    top: 400px;
}

@media only screen and (max-width: 700px){
.form1table {
    position:relative;
    top: auto;
}
}
</style>

